// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Text_Wrapper__3IwPE"};